import { PlusOutlined } from "@ant-design/icons";
import { Property } from "@dto/architecture.dto";
import { Button, Divider, SelectProps } from "antd";
import { FC, ReactElement, useCallback, useEffect, useMemo, useState } from "react";
import { XmSelect } from "src/component/select/XmSelect";
import { UnitOption } from "src/util/UnitHelper";

interface XmSelectPropertiesProps extends SelectProps<string[]> {
  propertyOptions: UnitOption<Property>[];
}

export const XmSelectProperties: FC<XmSelectPropertiesProps> = ({ propertyOptions, ...props }) => {

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setShowAll(prev => prev || propertyOptions?.length && (
      (// has no optional
      !(propertyOptions?.some((prop) => prop.base.isMandatory) && propertyOptions?.some(p => !p.base.isMandatory)) || props.value?.some(k => propertyOptions?.some(o => !o.base.isMandatory && o.value === k))) // has selected optional
    ));
  }, [propertyOptions, props.value]);

  const displayedOptions = useMemo<UnitOption<Property>[]>(() => {
    if (!propertyOptions?.length) return [];
    if (showAll) {
      return propertyOptions;
    }
    return propertyOptions.filter((uop) => uop.base.isMandatory);
  }, [propertyOptions, showAll]);

  const onLoadAll = useCallback((): void => {
    setShowAll(true);
  }, []);

  const dropdownRender = useCallback(
    (menu: ReactElement): ReactElement => (
      <>
        {menu}
        {!showAll && !!displayedOptions?.length && (
          <>
            <Divider style={{ margin: 0 }} />
            <Button style={{ width: '100%' }} type='link' onClick={onLoadAll}>
              <PlusOutlined />
              Show all
            </Button>
          </>
        )}
      </>
    ), [showAll, onLoadAll]);

  return <XmSelect
    placeholder='Select properties'
    mode='multiple'
    maxTagCount="responsive"
    allowClear
    showSearch={{ optionFilterProp: 'text' }}
    options={displayedOptions}
    ignoreReadonly
    popupRender={dropdownRender}
    {...props}
  />;
};